import React, { useEffect, useState, useRef, useContext } from 'react'
import PhaserGame from '../../../phaser-game/SSR-firewall'
import { Context } from './../../../context/app-context'
import useMediaQuery from './../../../utils/useMediaQuery'
import { navigate } from 'gatsby'
import './game.scss'

export default function Game() {
  const GAME_SCENE_ITERATOR = new Set([
    'pubertad',
    'utero',
    'flujo',
  ]).values()

  const [, forceUpdate] = useState()
  const isMobile = useMediaQuery()
  const [currentScene, setCurrentScene] = useState(
    GAME_SCENE_ITERATOR.next().value,
  )
  const { dispatch } = useContext(Context)
  const dataGameRef = useRef(new Set())
  const phaserPersistComponent = useRef()

  const handleEndgame = dataGames => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: 'endgame',
          props: {
            colorBlur: 'purple',
            dataGames,
          },
        },
      },
    })
  }


  const showModalGame = sceneKey => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `${sceneKey}Instructions`,
          props: {
            noClose: true,
            colorBlur: {
              utero: 'purple',
              pubertad: 'yellow',
              flujo: 'pink',
            }[sceneKey],
            handleCTA: () => {
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
              window.scrollTo(0, 0)
            },
          },
        },
      },
    })
  }

  const pushGameData = (__dataGame, __nextScene) => {
    dataGameRef.current.add({ ...__dataGame })
    const nextKeyScene = GAME_SCENE_ITERATOR.next().value
    if (nextKeyScene) {
      showModalGame(nextKeyScene)
      setCurrentScene(nextKeyScene)
      __nextScene(nextKeyScene)

    } else {
      handleEndgame(dataGameRef.current)

    }
  }


  useEffect(() => {
    if (isMobile !== null && phaserPersistComponent.current === undefined) {
      phaserPersistComponent.current = (
        <PhaserGame
          isMobile={isMobile}
          pushGameData={pushGameData}
          initialScene={currentScene}
        />
      )
      forceUpdate({})
    }
  }, [isMobile])

  useEffect(() => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: 'login',
          props: {
            close: () => {
              navigate('/')
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
            colorBlur: 'pink-login',
            handleStartGame: () => {
              showModalGame(currentScene)
            },
          },
        },
      },
    })

  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className={`f-game f-game--${currentScene}`}>
      <div className={`f-game__container f-game__container--${currentScene}`}>
        <div className={`f-game__game `}>{phaserPersistComponent.current}</div>
      </div>
    </div>
  )
}


